/* eslint-disable max-len */
export var LanguageName;
(function (LanguageName) {
    LanguageName["ABKHAZ"] = "Abkhaz";
    LanguageName["AFAR"] = "Afar";
    LanguageName["AFRIKAANS"] = "Afrikaans";
    LanguageName["AKAN"] = "Akan";
    LanguageName["ALBANIAN"] = "Albanian";
    LanguageName["AMHARIC"] = "Amharic";
    LanguageName["ARABIC"] = "Arabic";
    LanguageName["ARAGONESE"] = "Aragonese";
    LanguageName["ARMENIAN"] = "Armenian";
    LanguageName["ASSAMESE"] = "Assamese";
    LanguageName["AVARIC"] = "Avaric";
    LanguageName["AVESTAN"] = "Avestan";
    LanguageName["AYMARA"] = "Aymara";
    LanguageName["AZERBAIJANI"] = "Azerbaijani";
    LanguageName["BAMBARA"] = "Bambara";
    LanguageName["BASHKIR"] = "Bashkir";
    LanguageName["BASQUE"] = "Basque";
    LanguageName["BELARUSIAN"] = "Belarusian";
    LanguageName["BENGALI"] = "Bengali";
    LanguageName["BIHARI"] = "Bihari";
    LanguageName["BISLAMA"] = "Bislama";
    LanguageName["BOSNIAN"] = "Bosnian";
    LanguageName["BRETON"] = "Breton";
    LanguageName["BULGARIAN"] = "Bulgarian";
    LanguageName["BURMESE"] = "Burmese";
    LanguageName["CATALAN_VALENCIAN"] = "Catalan; Valencian";
    LanguageName["CHAMORRO"] = "Chamorro";
    LanguageName["CHECHEN"] = "Chechen";
    LanguageName["CHICHEWA_CHEWA_NYANJA"] = "Chichewa; Chewa; Nyanja";
    LanguageName["CHINESE"] = "Chinese";
    LanguageName["CHUVASH"] = "Chuvash";
    LanguageName["CORNISH"] = "Cornish";
    LanguageName["CORSICAN"] = "Corsican";
    LanguageName["CREE"] = "Cree";
    LanguageName["CROATIAN"] = "Croatian";
    LanguageName["CZECH"] = "Czech";
    LanguageName["DANISH"] = "Danish";
    LanguageName["DIVEHI_DHIVEHI_MALDIVIAN"] = "Divehi; Dhivehi; Maldivian;";
    LanguageName["DUTCH"] = "Dutch";
    LanguageName["ENGLISH"] = "English";
    LanguageName["ESPERANTO"] = "Esperanto";
    LanguageName["ESTONIAN"] = "Estonian";
    LanguageName["EWE"] = "Ewe";
    LanguageName["FAROESE"] = "Faroese";
    LanguageName["FIJIAN"] = "Fijian";
    LanguageName["FINNISH"] = "Finnish";
    LanguageName["FRENCH"] = "French";
    LanguageName["FULA_FULAH_PULAAR_PULAR"] = "Fula; Fulah; Pulaar; Pular";
    LanguageName["GALICIAN"] = "Galician";
    LanguageName["GEORGIAN"] = "Georgian";
    LanguageName["GERMAN"] = "German";
    LanguageName["GREEK_MODERN"] = "Greek, Modern";
    LanguageName["GUARAN"] = "Guaran\u00ED";
    LanguageName["GUJARATI"] = "Gujarati";
    LanguageName["HAITIAN_HAITIAN_CREOLE"] = "Haitian; Haitian Creole";
    LanguageName["HAUSA"] = "Hausa";
    LanguageName["HEBREW"] = "Hebrew";
    LanguageName["HERERO"] = "Herero";
    LanguageName["HINDI"] = "Hindi";
    LanguageName["HIRI_MOTU"] = "Hiri Motu";
    LanguageName["HUNGARIAN"] = "Hungarian";
    LanguageName["ICELANDIC"] = "Icelandic";
    LanguageName["IDO"] = "Ido";
    LanguageName["IGBO"] = "Igbo";
    LanguageName["INDONESIAN"] = "Indonesian";
    LanguageName["INTERLINGUA"] = "Interlingua";
    LanguageName["INTERLINGUE"] = "Interlingue";
    LanguageName["INUKTITUT"] = "Inuktitut";
    LanguageName["INUPIAQ"] = "Inupiaq";
    LanguageName["IRISH"] = "Irish";
    LanguageName["ITALIAN"] = "Italian";
    LanguageName["JAPANESE"] = "Japanese";
    LanguageName["JAVANESE"] = "Javanese";
    LanguageName["KALAALLISUT_GREENLANDIC"] = "Kalaallisut, Greenlandic";
    LanguageName["KANNADA"] = "Kannada";
    LanguageName["KANURI"] = "Kanuri";
    LanguageName["KASHMIRI"] = "Kashmiri";
    LanguageName["KAZAKH"] = "Kazakh";
    LanguageName["KHMER"] = "Khmer";
    LanguageName["KIKUYU_GIKUYU"] = "Kikuyu, Gikuyu";
    LanguageName["KINYARWANDA"] = "Kinyarwanda";
    LanguageName["KIRGHIZ_KYRGYZ"] = "Kirghiz, Kyrgyz";
    LanguageName["KIRUNDI"] = "Kirundi";
    LanguageName["KOMI"] = "Komi";
    LanguageName["KONGO"] = "Kongo";
    LanguageName["KOREAN"] = "Korean";
    LanguageName["KURDISH"] = "Kurdish";
    LanguageName["KWANYAMA_KUANYAMA"] = "Kwanyama, Kuanyama";
    LanguageName["LAO"] = "Lao";
    LanguageName["LATIN"] = "Latin";
    LanguageName["LATVIAN"] = "Latvian";
    LanguageName["LIMBURGISH_LIMBURGAN_LIMBURGER"] = "Limburgish, Limburgan, Limburger";
    LanguageName["LINGALA"] = "Lingala";
    LanguageName["LITHUANIAN"] = "Lithuanian";
    LanguageName["LUBA_KATANGA"] = "Luba-Katanga";
    LanguageName["LUGANDA"] = "Luganda";
    LanguageName["LUXEMBOURGISH_LETZEBURGESCH"] = "Luxembourgish, Letzeburgesch";
    LanguageName["MACEDONIAN"] = "Macedonian";
    LanguageName["MALAGASY"] = "Malagasy";
    LanguageName["MALAY"] = "Malay";
    LanguageName["MALAYALAM"] = "Malayalam";
    LanguageName["MALTESE"] = "Maltese";
    LanguageName["MANX"] = "Manx";
    LanguageName["MARATHI_MAR_H"] = "Marathi (Mar\u0101\u1E6Dh\u012B)";
    LanguageName["MARSHALLESE"] = "Marshallese";
    LanguageName["MONGOLIAN"] = "Mongolian";
    LanguageName["M_ORI"] = "M\u0101ori";
    LanguageName["NAURU"] = "Nauru";
    LanguageName["NAVAJO_NAVAHO"] = "Navajo, Navaho";
    LanguageName["NDONGA"] = "Ndonga";
    LanguageName["NEPALI"] = "Nepali";
    LanguageName["NORTHERN_SAMI"] = "Northern Sami";
    LanguageName["NORTH_NDEBELE"] = "North Ndebele";
    LanguageName["NORWEGIAN"] = "Norwegian";
    LanguageName["NORWEGIAN_BOKM_L"] = "Norwegian Bokm\u00E5l";
    LanguageName["NORWEGIAN_NYNORSK"] = "Norwegian Nynorsk";
    LanguageName["NUOSU"] = "Nuosu";
    LanguageName["OCCITAN"] = "Occitan";
    LanguageName["OJIBWE_OJIBWA"] = "Ojibwe, Ojibwa";
    LanguageName["OLD_CHURCH_SLAVONIC_CHURCH_SLAVIC_CHURCH_SLAVONIC_OLD_BULGARIAN_OLD_SLAVONIC"] = "Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic";
    LanguageName["ORIYA"] = "Oriya";
    LanguageName["OROMO"] = "Oromo";
    LanguageName["OSSETIAN_OSSETIC"] = "Ossetian, Ossetic";
    LanguageName["PANJABI_PUNJABI"] = "Panjabi, Punjabi";
    LanguageName["PASHTO_PUSHTO"] = "Pashto, Pushto";
    LanguageName["PERSIAN"] = "Persian";
    LanguageName["POLISH"] = "Polish";
    LanguageName["PORTUGUESE"] = "Portuguese";
    LanguageName["P_LI"] = "P\u0101li";
    LanguageName["QUECHUA"] = "Quechua";
    LanguageName["ROMANIAN_MOLDAVIAN_MOLDOVAN"] = "Romanian, Moldavian, Moldovan";
    LanguageName["ROMANSH"] = "Romansh";
    LanguageName["RUSSIAN"] = "Russian";
    LanguageName["SAMOAN"] = "Samoan";
    LanguageName["SANGO"] = "Sango";
    LanguageName["SANSKRIT_SA_SK_TA"] = "Sanskrit (Sa\u1E41sk\u1E5Bta)";
    LanguageName["SARDINIAN"] = "Sardinian";
    LanguageName["SCOTTISH_GAELIC_GAELIC"] = "Scottish Gaelic; Gaelic";
    LanguageName["SERBIAN"] = "Serbian";
    LanguageName["SHONA"] = "Shona";
    LanguageName["SINDHI"] = "Sindhi";
    LanguageName["SINHALA_SINHALESE"] = "Sinhala, Sinhalese";
    LanguageName["SLOVAK"] = "Slovak";
    LanguageName["SLOVENE"] = "Slovene";
    LanguageName["SOMALI"] = "Somali";
    LanguageName["SOUTHERN_SOTHO"] = "Southern Sotho";
    LanguageName["SOUTH_NDEBELE"] = "South Ndebele";
    LanguageName["SPANISH_CASTILIAN"] = "Spanish; Castilian";
    LanguageName["SUNDANESE"] = "Sundanese";
    LanguageName["SWAHILI"] = "Swahili";
    LanguageName["SWATI"] = "Swati";
    LanguageName["SWEDISH"] = "Swedish";
    LanguageName["TAGALOG"] = "Tagalog";
    LanguageName["TAHITIAN"] = "Tahitian";
    LanguageName["TAJIK"] = "Tajik";
    LanguageName["TAMIL"] = "Tamil";
    LanguageName["TATAR"] = "Tatar";
    LanguageName["TELUGU"] = "Telugu";
    LanguageName["THAI"] = "Thai";
    LanguageName["TIBETAN_STANDARD_TIBETAN_CENTRAL"] = "Tibetan Standard, Tibetan, Central";
    LanguageName["TIGRINYA"] = "Tigrinya";
    LanguageName["TONGA_TONGA_ISLANDS"] = "Tonga (Tonga Islands)";
    LanguageName["TSONGA"] = "Tsonga";
    LanguageName["TSWANA"] = "Tswana";
    LanguageName["TURKISH"] = "Turkish";
    LanguageName["TURKMEN"] = "Turkmen";
    LanguageName["TWI"] = "Twi";
    LanguageName["UIGHUR_UYGHUR"] = "Uighur, Uyghur";
    LanguageName["UKRAINIAN"] = "Ukrainian";
    LanguageName["URDU"] = "Urdu";
    LanguageName["UZBEK"] = "Uzbek";
    LanguageName["VENDA"] = "Venda";
    LanguageName["VIETNAMESE"] = "Vietnamese";
    LanguageName["VOLAP_K"] = "Volap\u00FCk";
    LanguageName["WALLOON"] = "Walloon";
    LanguageName["WELSH"] = "Welsh";
    LanguageName["WESTERN_FRISIAN"] = "Western Frisian";
    LanguageName["WOLOF"] = "Wolof";
    LanguageName["XHOSA"] = "Xhosa";
    LanguageName["YIDDISH"] = "Yiddish";
    LanguageName["YORUBA"] = "Yoruba";
    LanguageName["ZHUANG_CHUANG"] = "Zhuang, Chuang";
})(LanguageName || (LanguageName = {}));
//# sourceMappingURL=languages.js.map